import { Station, DataSample, DataSampleType, DataSampleUnit } from "../../domain/types";
import { updateSideBar } from "../../domain/visuals/sidebar";
import { UpdateStationSamples } from "../../main";
import { animateSpeedometerOutside } from "../markers/circleIcon";

const latestData = new Map<string, Map<DataSampleType, DataSample | undefined>>();

export function getLastUpdatedSampleTimestamp(station: Station): Date {
	const samples = latestData.get(station.Id.toUpperCase());
	let newest = new Date(0);
	if (samples !== undefined) {
		samples.forEach((value, key, map) => {
			if (value === undefined) {
				return;
			}
			if (new Date(value.Timestamp).getTime() > newest.getTime()) {
				newest = new Date(value.Timestamp);
			}
		});
	}
	return newest;
}
export function getLatestSample(station: Station, type: DataSampleType): DataSample | null {
	const sample = latestData.get(station.Id.toUpperCase())?.get(type);
	if (sample === undefined) {
		return null;
	}
	return sample;
}


export function getInvalidSamples(station: Station) {
	const samples = latestData.get(station.Id.toUpperCase());
	let countInvalid = 0;
	if (samples !== undefined) {
		samples.forEach((value, key, map) => {
			if (value == undefined) {
				return;
			}
			if (!value.Valid) {
				countInvalid++;
			}
		});
	}
	return { invalid: countInvalid, total: samples?.size ?? 0, valid: (samples?.size ?? countInvalid) - countInvalid };
}
export function setLatestSample(sample: DataSample, updateMarker: boolean = true): boolean {
	let currentMap = latestData.get(sample.StationId.toUpperCase());
	if (currentMap === undefined) {
		currentMap = new Map<DataSampleType, DataSample>();
	}
	currentMap.set(sample.Type, sample);
	latestData.set(sample.StationId.toUpperCase(), currentMap);
	if (updateMarker) {
		UpdateStationSamples(sample.StationId.toUpperCase());
		animateSpeedometerOutside(sample, 500);
		updateSideBar(sample);
	}
	return true;
}